import type { Region, SearcherIndexed } from '../types';
import { useI18n } from '@/core/plugins/i18n';

/**
 * Ключ ПС - для выбора нескольких ПС или регионов
 */
export const searhcerCompareKey = -1;

/**
 * Ключ ПС или индекса Региона, используется для ПС или Региона, не настроенных в проекте
 *
 * Также, используется для API с возможностью не указывать регион, см. `props.autoRegion`
 */
export const dummyIndex = -2;

/**
 * Регион - без региона
 */
export const globalRegionIndex = -1;

export const searchersNames = {
	0: 'Yandex',
	1: 'Google',
	4: 'YouTube',
	5: 'Bing',
	7: 'Seznam',
	8: 'AppStore',
	9: 'GoogleStore',
	20: 'Yandex.com',
	21: 'Yandex.com.tr',
};

export const regionUndefined: Region = {
	key: dummyIndex,
	name: '--',
	index: dummyIndex,
};

export const searcherUndefined: SearcherIndexed = {
	key: dummyIndex,
	name: '--',
	regions: [regionUndefined],
	regionByIndex: new Map([[dummyIndex, regionUndefined]]),
};

const regionAuto: Region = {
	key: dummyIndex,
	name: 'Autoselect',
	index: dummyIndex,
};

const searcherAuto: SearcherIndexed = {
	key: dummyIndex,
	name: 'Autoselect',
	regions: [regionAuto],
	regionByIndex: new Map([[dummyIndex, regionAuto]]),
};

const regionGlobal: Region = {
	countryCode: '00',
	depth: 1,
	device: 0,
	key: globalRegionIndex,
	index: globalRegionIndex,
	lang: 'ru',
	name: 'Without region',
};

export const getRegionAuto = () => {
	regionAuto.name = useI18n().Common.Autoselect!;

	return regionAuto;
};

export const getSearcherAuto = () => {
	getRegionAuto();

	searcherAuto.name = useI18n().Common.Autoselect!;
	console.log(searcherAuto);

	return searcherAuto;
};

export const getRegionGlobal = () => {
	regionGlobal.name = useI18n().Keywords.Without_region!;

	return regionGlobal;
};
